/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

// gimme: conversations-inbox-ui 06/03/2020 821760f11d8e24644cdad2f3d716922ae4e1456f
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled(UIButton).withConfig({
  displayName: "ActionButton__StyledButton",
  componentId: "sc-1rijit2-0"
})(["padding-left:0;padding-right:0;margin:0 !important;@media screen and (max-width:1212px){i18n-string{display:none;}}"]);
export const ActionButton = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const newProps = Object.assign({}, rest, {
    use: 'tertiary-light',
    className: `${className} m-all-0`,
    size: 'sm'
  });
  return /*#__PURE__*/_jsx(StyledButton, Object.assign({}, newProps, {
    children: children
  }));
};
export default ActionButton;